import { useSelector } from "react-redux";
import { isEmptyObject } from "@/src/components/common/common";
import { useEffect, useState } from "react";

const useAuth = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const userInfo = useSelector((state) => state?.user?.userInfo);
    const isUserLoggedIn =
        !isEmptyObject(userInfo) && userInfo.sessionId !== undefined; // Check if userInfo exists and sessionId is defined

    useEffect(() => {
        setIsLoggedIn(isUserLoggedIn);
    }, [isUserLoggedIn]);

    return { isLoggedIn }; // Return as an object for destructuring
};

export default useAuth;
